import React, { useEffect, useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useProjectsPage, useProjectsStore } from '../state/projects';
import { SitesMap } from '../components/SitesMap';
import { LoadingSpinner } from "../components/LoadingSpinner";

export const SitesMapPage: React.FC = () => {
  const { keycloak: { token } } = useKeycloak();
  const { loadProjectsPage } = useProjectsPage();
  const { projects } = useProjectsStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (token) {
        setIsLoading(true);
        try {
          await loadProjectsPage(1);
        } catch (error) {
          console.error('Error loading projects:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    loadData();
  }, [token, loadProjectsPage]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!projects || projects.length === 0) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#f5f5f5]">
        <div className="text-center">
          <div className="text-[#888] text-lg mb-2">No projects found</div>
          <div className="text-[#aaa] text-sm">Create a project to see sites on the map</div>
        </div>
      </div>
    );
  }

  return <SitesMap projects={projects} />;
}; 